import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Grid,
} from '@material-ui/core';

import CheckCircle from '@material-ui/icons/CheckCircle';

import { formatMoney } from '../../../utils/common';
import { useStyles } from './styles';
import { useStyles as useBaseStyles } from '../baseStyle';

function ContratarAbertura(props) {
  const classes = useStyles(props);
  const classesStylesBase = useBaseStyles(props);

  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const contratarServico = async () => {
    setLoading(true);

    history.push({
      pathname: '/payment-card',
      state: {
        item: props.location.state.item,
        signaturePlan: props.location.state.signaturePlan,
        user: props.location.state.user,
        portal: props.location.state.portal,
      },
    });

    setLoading(false);
  };

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classesStylesBase.grid}
    >
      <Paper elevation={10} className={classesStylesBase.root}>
        <div className={classesStylesBase.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classesStylesBase.logo}
          />
        </div>
        <Typography className={classes.header}>SERVIÇO</Typography>
        <Typography className={classes.title}>
          {props.location.state.item.nome}
        </Typography>
        <Card>
          <CardHeader subheader={props.location.state.item.descricao} />

          <CardContent>
            <div>
              <Typography className={classes.textDocumentRequired}>
                Documentação necessária:
              </Typography>
              {props.location.state.item.documentos_necessario_servicos?.map(
                (documento) => (
                  <div
                    key={documento.id_documento_necessario}
                    className={classes.viewImageDescription}
                  >
                    <Typography className={classes.textDocumentRequired}>
                      <CheckCircle htmlColor="green" className={classes.icon} />
                      {documento.DocumentoNecessario.nome}
                    </Typography>
                  </div>
                )
              )}
            </div>
          </CardContent>
        </Card>
        <Card style={{ width: '100%', marginTop: '20px' }}>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'block' }}
                className={classes.textValue}
              >
                SERVIÇO
              </Typography>
              <Typography style={{ display: 'block' }} className={classes.text}>
                {props.location.state.item.valor &&
                  formatMoney(props.location.state.item.valor)}
              </Typography>
            </div>
          </CardContent>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'block' }}
                className={classes.textValue}
              >
                ASSINATURA
              </Typography>
              <Typography style={{ display: 'block' }} className={classes.text}>
                {props.location.state.signaturePlan.valor &&
                  formatMoney(
                    parseFloat(props.location.state.signaturePlan.valor / 100)
                  )}
              </Typography>
            </div>
          </CardContent>
        </Card>
        <Card style={{ width: '100%', marginTop: '20px' }}>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'inline-block' }}
                className={classes.textValue}
              >
                TOTAL
              </Typography>
              <Typography
                style={{ display: 'inline-block' }}
                className={classes.text}
              >
                {props.location.state.signaturePlan.valor &&
                  formatMoney(
                    parseFloat(props.location.state.signaturePlan.valor / 100) +
                      props.location.state.item.valor
                  )}
              </Typography>
            </div>
          </CardContent>
        </Card>

        <Button
          type="button"
          variant="contained"
          fullWidth
          // disabled={!isValid}
          className={classes.submit}
          onClick={() => contratarServico()}
        >
          {loading ? (
            <CircularProgress color="primary" size={25} />
          ) : (
            'CONTRATAR'
          )}
        </Button>
      </Paper>
    </Grid>
  );
}

export default ContratarAbertura;
